import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c1f1971a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "Main"
};
var _hoisted_2 = {
  class: "footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NavHeaderVue = _resolveComponent("NavHeaderVue");

  var _component_el_header = _resolveComponent("el-header");

  var _component_NavAsideVue = _resolveComponent("NavAsideVue");

  var _component_el_scrollbar = _resolveComponent("el-scrollbar");

  var _component_el_aside = _resolveComponent("el-aside");

  var _component_el_col = _resolveComponent("el-col");

  var _component_router_view = _resolveComponent("router-view");

  var _component_el_main = _resolveComponent("el-main");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_container = _resolveComponent("el-container");

  var _component_PlayerDetail = _resolveComponent("PlayerDetail");

  var _component_Player = _resolveComponent("Player");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 导航 "), _createVNode(_component_el_container, null, {
    default: _withCtx(function () {
      return [_createCommentVNode(" 头部 "), _createVNode(_component_el_header, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_NavHeaderVue)];
        }),
        _: 1
        /* STABLE */

      }), _createVNode(_component_el_container, {
        class: "nav-center"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_row, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_col, {
                span: 4
              }, {
                default: _withCtx(function () {
                  return [_createCommentVNode(" 菜单 "), _createVNode(_component_el_aside, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_scrollbar, {
                        height: "560px"
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_NavAsideVue)];
                        }),
                        _: 1
                        /* STABLE */

                      })];
                    }),
                    _: 1
                    /* STABLE */

                  })];
                }),
                _: 1
                /* STABLE */

              }), _createVNode(_component_el_col, {
                span: 20
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_scrollbar, {
                    height: "560px",
                    class: "el-loading"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_main, null, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_router_view, null, {
                            default: _withCtx(function (_ref) {
                              var Component = _ref.Component;
                              return [_createVNode(_Transition, {
                                name: "wzp"
                              }, {
                                default: _withCtx(function () {
                                  return [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))];
                                }),
                                _: 2
                                /* DYNAMIC */

                              }, 1024
                              /* DYNAMIC_SLOTS */
                              )];
                            }),
                            _: 1
                            /* STABLE */

                          })];
                        }),
                        _: 1
                        /* STABLE */

                      })];
                    }),
                    _: 1
                    /* STABLE */

                  })];
                }),
                _: 1
                /* STABLE */

              })];
            }),
            _: 1
            /* STABLE */

          })];
        }),
        _: 1
        /* STABLE */

      })];
    }),
    _: 1
    /* STABLE */

  }), _createCommentVNode(" 脚部 "), _createVNode(_component_PlayerDetail), _createElementVNode("div", _hoisted_2, [_createVNode(_component_Player)])]);
}